export default __webpack_public_path__ + "static/content1-d4095f7477164aa596779b084097e4be.png";